import { render, staticRenderFns } from "./QrcodeAdd.vue?vue&type=template&id=823872fa&scoped=true&"
import script from "./QrcodeAdd.vue?vue&type=script&lang=js&"
export * from "./QrcodeAdd.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeAdd.vue?vue&type=style&index=0&id=823872fa&prod&lang=css&"
import style1 from "./QrcodeAdd.vue?vue&type=style&index=1&id=823872fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823872fa",
  null
  
)

export default component.exports